<template>
  <div class="property-wrapper">
    <div class="logo">
            <img class="logo" src="../assets/icons/propmate_logo.png" />
        </div>
        <div class="login-text">
          Login to you account to continue
        </div>
    <div class="row justify-content-center">
      <div class="align-items-center property-container">
        <div class="property-card">
          <p>Select a property to continue</p>
          <PropertyList/>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import PropertyList from "../components/ProperyList";
export default {
  name: 'Properties',
  components: {
    PropertyList
  }
};
</script>

<style lang="scss" scoped>
@import "../styles/_variables";
$colorPink: #f4e8e5;
$colorRed: #fc5657;
.property-wrapper{
  position: fixed;
  top: 0px;
  left: 0px;
  right: 0px;
  bottom: 0px;
  width: 100vw;
  display: flex;
  flex-direction: column;
  align-items:center;
  background-image: linear-gradient(to bottom, $colorRed 30%, $colorPink 30%);
    .logo{
        max-width: 250px;
        margin-top: 25px;
        padding-right: 5px;
    }
    .login-text {
        font-family: Inter-Regular;
        font-size: 14px;
        color: #fff;
        letter-spacing: 0;
        line-height: 30px;
        font-weight: 500;
        margin-top: 10px;
    }
  .title-container {
    margin-top: 60px;
    font-family: HelveticaNeue-Bold;
    font-size: 30px;
    color: #FFFFFF;
    letter-spacing: 0;
    text-align: center;
  }
  .property-container{
    height: 100vh;
    display: flex;
    flex-direction: column;
    margin-top: 50px;
    .property-card {
      width: 600px;
      background: #FFFFFF;
      border: 1px solid #ecececa2;
      box-shadow: 0px 1px 30px 0 rgba(0,0,0,0.08);
      margin-bottom: 200px;
      >p {
        padding-top: 42px;
        padding-bottom: 31px;
        margin-bottom: 0px;
        font-family: HelveticaNeue;
        font-size: 14px;
        color: #4A4A4A;
        letter-spacing: 0;
        text-align: center;
        background: #FFFFFF;
        z-index: 2;
        position: relative;
        border-bottom: 1px solid #ecececa2;
      }
      h3 {
        font-weight: 400;
        font-size: 30px;
        line-height: 1;
        margin: 90px 0 30px 0;
      }
    }
    
  }
}
</style>
